import { AuthStoreState } from "@store/auth.store";
import sidekickLogo from "@assets/sidekick-logo.svg";

export type MessageSuggestionModel = {
  id: string;
  displayText?: string;
  displayFormat?: string;
  prompt: string;
  type: "text" | "file" | string;
  autoSubmit?: boolean;
  typewriterSuggestions?: string[];
  icon?: string;
  iconColor?: string;
  hidden?: boolean;
  url?: string;
};

export const SIDEKICK_NAME = "Sidekick - Real Estate Assistant";

export const getAuthor = (params: {
  createdBy: string;
  user: AuthStoreState["user"] | null;
}): { name: string; avatar: string } => {
  const { createdBy, user } = params;
  if (createdBy === "assistant" || createdBy === "bot") {
    return {
      name: SIDEKICK_NAME,
      avatar: sidekickLogo,
    };
  }
  return {
    name: user?.name || "User",
    avatar: user?.avatar || "",
  };
};

export const CHAT_CONTENT_MAX_WIDTH = "1240px";
